import "./hero-slider.scss";

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//
import Swiper from "swiper/bundle";

const heroSlider = () => {
    let heroSliderAll = document.querySelectorAll(".im-hero-slider");
    if (!heroSliderAll.length) return;

    heroSliderAll.forEach((el) => {
        let arrowPrev = el.querySelector(".swiper-button-prev");
        let arrowNext = el.querySelector(".swiper-button-next");

        let pagination = el.querySelector(".swiper-pagination");

        let typePagination = "bullets";

        if (pagination) {
            switch (true) {
                case pagination.classList.contains("bullets"):
                    typePagination = "bullets";
                    break;
                case pagination.classList.contains("fraction"):
                    typePagination = "fraction";
                    break;
                case pagination.classList.contains("progressbar"):
                    typePagination = "progressbar";
                    break;
                default:
                    typePagination = "bullets";
                    break;
            }
        }

        let img = new Swiper(
            el.querySelector(".im-hero-slider__media-slider .swiper-container"),
            {
                slidesPerView: 1,
                spaceBetween: 0,
                simulateTouch: false,
                allowTouchMove: false,
                speed: 700,
                effect: "fade",

                // fadeEffect: {
                //     crossFade: true,
                // },
                // navigation: {
                //     nextEl: arrowNext,
                //     prevEl: arrowPrev,
                // },
            }
        );

        let text = new Swiper(
            el.querySelector(".im-hero-slider__text-slider .swiper-container"),
            {
                slidesPerView: "auto",
                spaceBetween: 0,
                effect: "fade",
                watchSlidesProgress: true,
                fadeEffect: {
                    crossFade: true,
                },
                thumbs: {
                    swiper: img,
                },
                pagination: {
                    el: pagination,
                    clickable: true,
                    type: typePagination,
                },
                navigation: {
                    nextEl: arrowNext,
                    prevEl: arrowPrev,
                },
            }
        );
    });
};

export default heroSlider;
